<template>
  <nav>
    <v-toolbar app dark color="primary">
      <v-toolbar-side-icon
        class="white--text"
        @click="drawer = !drawer"
      ></v-toolbar-side-icon>
      <v-toolbar-title class="text-uppercase white--text">
        <div v-if="!drawer && !loggedIn" class="mt-2">
          <img
            :src="require('../assets/gm-white-200.png')"
            width="150px"
            alt="Groupmail"
            @click="viewDashboard"
          />
        </div>
        <span
          v-if="loggedIn"
          :style="{ cursor: 'pointer' }"
          @click="viewDashboard"
          >{{ teamname }}</span
        >
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        v-if="!loggedIn"
        class="hidden-xs-only"
        color="white--text"
        flat
        round
        to="/login"
      >
        <span>Login</span>
      </v-btn>
      <v-btn
        v-if="!loggedIn"
        class="hidden-xs-only"
        color="accent"
        light
        depressed
        round
        to="/signup"
      >
        <span>Sign Up</span>
      </v-btn>
      <v-menu v-if="loggedIn" offset-y>
        <v-btn slot="activator" flat color="white">
          <Avatar
            :username="username"
            :src="avatarSource"
            :size="$options.avatarTool"
            class="mr-0"
          ></Avatar>
          <span class="hidden-xs-only ml-2">{{ username }}</span>
          <v-icon right class="ml-0">expand_more</v-icon>
        </v-btn>
        <v-list>
          <v-list-tile v-if="isActiveAccount" to="/account">
            <v-list-tile-title>Usage</v-list-tile-title>
          </v-list-tile>
          <v-list-tile v-if="isActiveAccount" to="/billing">
            <v-list-tile-title>Plan & Billing History</v-list-tile-title>
          </v-list-tile>
          <v-divider></v-divider>
          <v-list-tile v-if="isActiveAccount" to="/profile">
            <v-list-tile-title>Profile</v-list-tile-title>
          </v-list-tile>
          <v-list-tile v-if="isTeamOwner && isActiveAccount" to="/team/profile">
            <v-list-tile-title>Team Profile</v-list-tile-title>
          </v-list-tile>
          <!--          <v-list-tile to="/team/members">-->
          <!--            <v-list-tile-title>Team Members</v-list-tile-title>-->
          <!--          </v-list-tile>-->
          <!--          <v-divider></v-divider>-->
          <v-divider></v-divider>
          <v-list-tile href="https://help.groupmail.io/">
            <v-list-tile-title>Technical Support</v-list-tile-title>
          </v-list-tile>
          <v-divider></v-divider>
          <v-list-tile @click="logout">
            <v-list-tile-title>Logout</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>

    <v-navigation-drawer v-model="drawer" app class="primary">
      <div class="ma-3">
        <img
          :src="require('../assets/gm-white-200.png')"
          width="150px"
          alt="Groupmail"
        />
        <v-divider class="mt-2"></v-divider>
      </div>
      <v-toolbar v-if="loggedIn" flat class="transparent" dark>
        <v-list class="pa-0 mt-0">
          <v-list-tile avatar @click="viewProfile">
            <Avatar
              :username="username"
              :src="avatarSource"
              :size="$options.avatarNav"
              class="mr-3"
            ></Avatar>
            <v-list-tile-content>
              <v-list-tile-title>{{ fullname }}</v-list-tile-title>
              <v-list-tile-sub-title>{{ teamname }}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-toolbar>
      <v-list v-if="loggedIn" class="pa-0">
        <v-divider class="mt-2"></v-divider>
        <!--        <v-list-tile to="/dashboard" active-class="v-list__tile&#45;&#45;highlighted">-->
        <!--          <v-list-tile-action>-->
        <!--            <v-icon class="white&#45;&#45;text">dashboard</v-icon>-->
        <!--          </v-list-tile-action>-->
        <!--          <v-list-tile-content>-->
        <!--            <v-list-tile-title class="white&#45;&#45;text">Dashboard</v-list-tile-title>-->
        <!--          </v-list-tile-content>-->
        <!--        </v-list-tile>-->
        <!--        <v-list-tile to="/groups" active-class="v-list__tile&#45;&#45;highlighted">-->
        <!--          <v-list-tile-action>-->
        <!--            <v-icon class="white&#45;&#45;text">group</v-icon>-->
        <!--          </v-list-tile-action>-->
        <!--          <v-list-tile-content>-->
        <!--            <v-list-tile-title class="white&#45;&#45;text">Groups</v-list-tile-title>-->
        <!--          </v-list-tile-content>-->
        <!--        </v-list-tile>-->
        <!--        <v-list-tile to="/live" active-class="v-list__tile&#45;&#45;highlighted">-->
        <!--          <v-list-tile-action>-->
        <!--            <v-icon class="white&#45;&#45;text">poll</v-icon>-->
        <!--          </v-list-tile-action>-->
        <!--          <v-list-tile-content>-->
        <!--            <v-list-tile-title class="white&#45;&#45;text"-->
        <!--              >Live Events</v-list-tile-title-->
        <!--            >-->
        <!--          </v-list-tile-content>-->
        <!--        </v-list-tile>-->
        <!--        <v-divider></v-divider>-->
        <v-list-tile
          v-if="isActiveAccount"
          to="/downloads"
          active-class="v-list__tile--highlighted"
        >
          <v-list-tile-action>
            <v-icon class="white--text">computer</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title class="white--text">Downloads</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile
          v-if="isActiveAccount"
          to="/account"
          active-class="v-list__tile--highlighted"
        >
          <v-list-tile-action>
            <v-icon class="white--text">show_chart</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title class="white--text">Usage</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
          v-if="isActiveAccount"
          to="/billing"
          active-class="v-list__tile--highlighted"
        >
          <v-list-tile-action>
            <v-icon class="white--text">credit_card</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title class="white--text"
              >Plan & Billing History</v-list-tile-title
            >
          </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile
          v-if="isActiveAccount"
          to="/profile"
          active-class="v-list__tile--highlighted"
        >
          <v-list-tile-action>
            <v-icon class="white--text">person_outline</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title class="white--text">Profile</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
          v-if="isTeamOwner && isActiveAccount"
          to="/team/profile"
          active-class="v-list__tile--highlighted"
        >
          <v-list-tile-action>
            <v-icon class="white--text">work_outline</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title class="white--text"
              >Team Profile</v-list-tile-title
            >
          </v-list-tile-content>
        </v-list-tile>
        <!--        <v-list-tile-->
        <!--          to="/team/members"-->
        <!--          active-class="v-list__tile&#45;&#45;highlighted"-->
        <!--        >-->
        <!--          <v-list-tile-action>-->
        <!--            <v-icon class="white&#45;&#45;text">people_outline</v-icon>-->
        <!--          </v-list-tile-action>-->
        <!--          <v-list-tile-content>-->
        <!--            <v-list-tile-title class="white&#45;&#45;text"-->
        <!--              >Team Members</v-list-tile-title-->
        <!--            >-->
        <!--          </v-list-tile-content>-->
        <!--        </v-list-tile>-->
        <!--        <v-divider></v-divider>-->
        <v-divider></v-divider>
        <v-list-tile @click="logout">
          <v-list-tile-action>
            <v-icon class="white--text">exit_to_app</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title class="white--text">Logout</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-list v-if="!loggedIn">
        <v-list-tile to="/login" active-class="v-list__tile--highlighted">
          <v-list-tile-action>
            <v-icon class="white--text">vpn_key</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title class="white--text">Login</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile to="/signup" active-class="v-list__tile--highlighted">
          <v-list-tile-action>
            <v-icon class="white--text">create</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title class="white--text">Signup</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
  </nav>
</template>

<script>
// import io from 'socket.io-client';
import Avatar from 'vue-avatar';
import { mapGetters, mapActions, mapState } from 'vuex';

// const socket = io('https://live.groupmail.net', {
//   reconnect: true,
//   transports: ['polling', 'websocket']
// });

export default {
  components: { Avatar },
  avatarNav: 40, // non reactive way of setting options
  avatarTool: 28, // non reactive... access using $options
  data: function() {
    return {
      drawer: true
    };
  },
  computed: {
    ...mapState('auth', ['account']),
    ...mapGetters('auth', [
      'loggedIn',
      'teamname',
      'teamId',
      'apiKey',
      'avatarSource',
      'fullname',
      'username',
      'isTeamOwner'
    ]),
    isActiveAccount() {
      if (this.account) {
        return (
          this.account.status === 'TRIAL' ||
          this.account.status === 'ACTIVE' ||
          this.account.status === 'FREE'
        );
      }
      return false;
    }
  },
  sockets: {
    connect() {
      console.log('Connected to live reporter');
      if (this.teamId) {
        console.log('Listening for changes to', this.teamId);
        this.$socket.emit('team', this.teamId);
      }
    },
    disconnect() {
      console.log('Disconnected from live reporter');
    },
    // eslint-disable-next-line no-unused-vars
    team(data) {
      console.log('LIVE team updated', data);
      this.getTeam();
    },
    // eslint-disable-next-line no-unused-vars
    account(data) {
      console.log('LIVE account updated', data);
      this.getAccount();
    },
    // MOVE THE GROUP LISTENER TO THE GROUPS PAGE
    group(data) {
      console.log('LIVE group updated', data);
      this.getGroups();
    },
    user(data) {
      console.log('LIVE user updated', data);
      this.reloadUser(data);
    }
  },
  beforeDestroy: function() {
    this.$socket.close();
  },
  watch: {
    loggedIn: function(newValue) {
      if (newValue === false) {
        this.$socket.close();
        this.$store
          .dispatch('auth/refresh')
          .then(response => {
            if (!response) {
              // eslint-disable-next-line no-unused-vars
              this.$router.push('/login').catch(err => {});
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch(e => {
            // eslint-disable-next-line no-unused-vars
            this.$router.push('/login').catch(err => {});
          });
      } else {
        this.$socket.connect();
      }
    }
  },
  methods: {
    viewProfile() {
      if (this.account) {
        if (
          this.account.status === 'TRIAL' ||
          this.account.status === 'ACTIVE'
        ) {
          this.$router.push('/profile');
        }
      }
    },
    viewDashboard() {
      if (this.account) {
        if (
          this.account.status === 'TRIAL' ||
          this.account.status === 'ACTIVE'
        ) {
          this.$router.push('/account');
        }
      }
    },
    logout() {
      this.resetUser();
      this.resetAccount();
      this.$router.push('/login').catch(err => {}); // eslint-disable-line
    },
    ...mapActions({
      getGroups: 'account/getGroups',
      resetUser: 'auth/resetUser',
      reloadUser: 'auth/reloadUser',
      getTeam: 'auth/getTeam',
      getUser: 'auth/getUser',
      reloadAccount: 'auth/reloadAccount',
      getAccount: 'auth/getAccount',
      resetAccount: 'account/resetAccount'
    })
  }
};
</script>
